export default {
  nav: {
    lite: 'Lite',
    new: 'Nouveau',
  },
  footer: {
    links: {
      lite: 'Geofleet Lite',
    },
  },
  litePage: {
    seoTitle: 'Geofleet Lite — Logiciel de gestion des livraisons simple pour les petites entreprises',
    seoDescription:
      'Geofleet Lite est une solution de livraison pour un seul hub dès 49 $ par mois avec 3 chauffeurs et 500 commandes. Lite Plus ajoute tournées, attribution automatique, WhatsApp et API pour 99 $. Lite Autopilot ajoute AI Copilot et Autopilot pour 179 $. Jusqu’à 20 % d’économie en facturation annuelle.',
    breadcrumb: 'Geofleet Lite',

    heroBadge: 'Geofleet Lite',
    heroEyebrow: 'La gestion des livraisons simple pour les petites entreprises',
    heroTitle: 'Votre hub. Vos chauffeurs.',
    heroTitleHighlight: 'Chaque livraison sur un seul écran.',
    /** Direct answer paragraph — quotable by search and AI answer engines. */
    heroLead:
      'Geofleet Lite est un logiciel de livraison pour les petites entreprises qui ont quelques chauffeurs et un seul point de départ : une boutique, une cuisine, une pharmacie ou un entrepôt. Ajoutez vos commandes, planifiez les tournées du jour, suivez vos chauffeurs sur une carte en direct et envoyez à chaque client un lien de suivi. Fini les tableurs et les relances dans les groupes WhatsApp.',
    ctaPrimary: 'Démarrer avec Lite',
    ctaSecondary: 'Voir comment ça marche',
    heroFacts: [
      { icon: 'ri-price-tag-3-line', label: 'Plans dès 49 $/mois' },
      { icon: 'ri-user-line', label: '3 chauffeurs inclus' },
      { icon: 'ri-file-list-3-line', label: '500 commandes incluses' },
    ],
    heroVisualAlt: 'Tableau de bord Geofleet Lite avec les commandes du jour, l’état des livraisons, un résumé Copilot et les alertes de retard',
    heroDriverAlt: 'Application chauffeur Geofleet Lite avec l’arrêt en cours, l’encaissement à percevoir et les arrêts du jour',
    heroTrackAlt: 'Page de suivi client avec la position du chauffeur en direct et l’heure d’arrivée',
    screenshotOf: 'Écran Geofleet Lite : {{title}}',

    problemKicker: 'Ça vous parle ?',
    problemTitle: 'La plupart des petites équipes de livraison tournent avec des groupes de discussion et de la mémoire',
    problems: [
      { icon: 'ri-whatsapp-line', title: 'Des commandes éparpillées partout', text: 'Les commandes arrivent par téléphone, WhatsApp et votre boutique en ligne, et quelqu’un les recopie dans un tableur.' },
      { icon: 'ri-route-line', title: 'Des tournées planifiées de tête', text: 'Les chauffeurs zigzaguent en ville parce que personne n’a le temps de trier 30 arrêts à la main.' },
      { icon: 'ri-phone-line', title: 'Les appels « Où est ma commande ? »', text: 'Le client appelle la boutique, la boutique appelle le chauffeur, et tout le monde attend.' },
      { icon: 'ri-money-dollar-circle-line', title: 'Une caisse qui ne tombe pas juste', text: 'Le paiement à la livraison se règle en fin de journée, à coups de notes griffonnées et de souvenirs.' },
    ],

    setupKicker: 'Lancez-vous dès aujourd’hui',
    setupTitle: 'Cinq étapes rapides, puis votre première livraison',
    setupIntro: 'Lite ne vous demande que l’essentiel pour faire tourner vos livraisons. Tout reste modifiable plus tard dans les Paramètres.',
    setupSteps: [
      { icon: 'ri-store-2-line', title: 'Votre entreprise', text: 'Nom, logo et numéro de support, pour que vos clients vous reconnaissent.' },
      { icon: 'ri-map-pin-2-line', title: 'Point d’enlèvement', text: 'Votre hub : là où chaque tournée commence et se termine.' },
      { icon: 'ri-time-line', title: 'Horaires d’activité', text: 'Les créneaux où vos chauffeurs livrent.' },
      { icon: 'ri-shield-check-line', title: 'Règles de livraison', text: 'Preuve de livraison, nouvelles tentatives et numéros de commande.' },
      { icon: 'ri-message-3-line', title: 'Messages clients', text: 'Choisissez SMS, WhatsApp ou e-mail pour les liens de suivi.' },
    ],

    dayKicker: 'Une journée avec Lite',
    dayTitle: 'Tout ce que fait une entreprise de livraison mono-hub, sur un seul écran',
    dayItems: [
      {
        icon: 'ri-file-list-3-line',
        title: 'Prendre les commandes',
        text: 'Ajoutez une commande en quelques secondes avec la recherche d’adresse, un créneau de livraison et le montant à encaisser, ou importez un CSV pour toute la journée.',
        points: ['Saisie automatique des adresses', 'Recherche des clients réguliers', 'Import CSV'],
      },
      {
        icon: 'ri-route-line',
        title: 'Planifier les tournées',
        text: 'Sélectionnez les commandes et les chauffeurs du jour, cliquez sur Optimiser, puis faites glisser les arrêts pour affiner avant de publier sur les téléphones des chauffeurs.',
        points: ['Optimisation en un clic depuis votre hub', 'Réordonner ou déplacer des arrêts', 'Publication vers l’app chauffeur'],
      },
      {
        icon: 'ri-map-pin-time-line',
        title: 'Suivre en direct',
        text: 'Visualisez chaque chauffeur et chaque commande sur une seule carte avec des ETA en direct, et réattribuez ou partagez un lien directement depuis la carte.',
        points: ['Vues chauffeurs et commandes', 'ETA en direct par arrêt', 'Liste des points à traiter'],
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Prouver la livraison et encaisser',
        text: 'Les chauffeurs capturent la preuve à la porte et enregistrent les espèces encaissées. Vous voyez qui détient combien et vous soldez en un geste.',
        points: ['Photo, signature ou nom du destinataire', 'Espèces détenues par chauffeur', 'Solder la caisse et télécharger les rapports'],
      },
    ],

    hubKicker: 'Conçu pour un seul hub',
    hubTitle: 'Pensé pour le quotidien réel des petites entreprises de livraison',
    hubPoints: [
      { icon: 'ri-home-4-line', title: 'Un seul point d’enlèvement, défini une fois', text: 'Chaque commande part de votre hub : plus besoin de saisir une adresse d’enlèvement.' },
      { icon: 'ri-user-smile-line', title: 'Un lien de suivi pour vos clients', text: 'À votre logo et à vos couleurs. Aucune app à installer pour vos clients.' },
      { icon: 'ri-smartphone-line', title: 'Une app chauffeur qui va à l’essentiel', text: 'Arrêt en cours, navigation, appel et preuve de livraison. C’est tout.' },
      { icon: 'ri-bar-chart-2-line', title: 'Les chiffres du jour en un coup d’œil', text: 'Livrées, échouées, à l’heure et ce qui demande votre attention, dès l’ouverture de Lite.' },
    ],

    industriesTitle: 'Plébiscité par',
    industries: [
      { label: 'Restaurants et dark kitchens', href: '/industries/restaurants' },
      { label: 'Pharmacies', href: '/industries/pharmacies' },
      { label: 'Épiceries et dark stores', href: '/industries/grocery' },
      { label: 'Fleuristes', href: '/industries/flowers' },
      { label: 'Blanchisseries', href: '/industries/laundry' },
      { label: 'Livraison d’eau', href: '/industries/water' },
    ],

    compareKicker: 'Lite ou la plateforme complète ?',
    compareTitle: 'Commencez avec Lite. Passez à Geofleet sans tout recommencer.',
    compareIntro:
      'Lite repose sur la même plateforme Geofleet. Quand vous ouvrez un deuxième hub ou voulez le dispatch par IA, vous changez simplement de plan et conservez toutes vos commandes, vos chauffeurs et votre historique.',
    compareColFeature: 'Vos besoins',
    compareColLite: 'Geofleet Lite',
    compareColPlatform: 'Geofleet Command',
    compareRows: [
      { feature: 'Prix', lite: '49 $ Lite · 99 $ Lite Plus · 179 $ Lite Autopilot', platform: 'À partir de 19 $ par chauffeur / mois' },
      { feature: 'Chauffeurs', lite: '3 · 10 · 25 inclus', platform: 'Minimum 10 chauffeurs' },
      { feature: 'Commandes', lite: '500 · 1 000 · 2 000 par mois', platform: '5 000+ selon le plan et les chauffeurs' },
      { feature: 'Hubs', lite: 'Un seul', platform: 'Multi-hubs et multi-étapes' },
      { feature: 'Planification des tournées, suivi en direct, preuve de livraison', lite: 'yes', platform: 'yes' },
      { feature: 'Liens de suivi client', lite: 'yes', platform: 'yes' },
      { feature: 'Shopify et WooCommerce', lite: 'Dès Lite Plus', platform: 'Dès Professional' },
      { feature: 'Planification des tournées et attribution automatique', lite: 'Dès Lite Plus', platform: 'yes' },
      { feature: 'Commandes et automatisation WhatsApp', lite: 'Dès Lite Plus', platform: 'yes' },
      { feature: 'API et webhooks', lite: 'Dès Lite Plus', platform: 'yes' },
      { feature: 'AI Copilot et Autopilot', lite: 'Lite Autopilot', platform: 'Dès Professional' },
      { feature: 'Suite complète d’agents IA', lite: 'no', platform: 'yes' },
      { feature: 'Attribution aux transporteurs, SLA et AI Command Centre', lite: 'no', platform: 'yes' },
    ],
    compareYes: 'Inclus',
    compareNo: 'Non inclus',
    compareCta: 'Comparer tous les plans',

    guidesTitle: 'Guides pour les équipes à un seul hub',
    guides: [
      { label: 'Découvrez Geofleet Lite', href: '/blog/introducing-geofleet-lite' },
      { label: 'Gérer les livraisons depuis un seul hub : le guide quotidien', href: '/blog/single-hub-delivery-management-guide' },
      { label: 'Vos livraisons sur un groupe WhatsApp ? Quand passer à autre chose', href: '/blog/whatsapp-group-delivery-management-alternative' },
      { label: 'Comment planifier les tournées de livraison d’une petite entreprise', href: '/blog/how-to-plan-delivery-routes-small-business' },
    ],

    faqTitle: 'FAQ Geofleet Lite',
    faqs: [
      {
        question: 'Qu’est-ce que Geofleet Lite ?',
        answer:
          'Geofleet Lite est une version simplifiée de Geofleet pour les petites entreprises qui livrent depuis un seul hub. Elle couvre les commandes, la planification des tournées, le suivi des chauffeurs en direct, les liens de suivi client, la preuve de livraison et la gestion du paiement à la livraison.',
      },
      {
        question: 'Combien coûte Geofleet Lite ?',
        answer: 'Lite coûte 49 $ par mois et inclut 3 chauffeurs et 500 commandes. Lite Plus coûte 99 $ et inclut 10 chauffeurs et 1 000 commandes. Lite Autopilot coûte 179 $ et inclut 25 chauffeurs et 2 000 commandes. La facturation trimestrielle fait économiser environ 10 % et l’annuelle jusqu’à 20 %. Les trois plans sont réservés à un seul hub.',
      },
      {
        question: 'Geofleet Lite est-il gratuit ?',
        answer: 'Non. Lite commence à 49 $ par mois avec 3 chauffeurs et 500 commandes. Vous pouvez l’essayer pendant 7 jours avec jusqu’à 100 commandes.',
      },
      {
        question: 'À qui s’adresse Geofleet Lite ?',
        answer:
          'Aux restaurants, pharmacies, épiceries, fleuristes, blanchisseries, fournisseurs d’eau et autres commerces locaux qui envoient leurs propres chauffeurs depuis une seule boutique, cuisine ou entrepôt.',
      },
      {
        question: 'Mes chauffeurs ont-ils besoin d’une app spécifique ?',
        answer: 'Les chauffeurs utilisent l’app chauffeur Geofleet sur leur téléphone pour voir leurs arrêts, naviguer et capturer la preuve de livraison. Vos clients n’ont besoin d’aucune app : ils reçoivent un lien de suivi.',
      },
      {
        question: 'Que se passe-t-il quand Lite ne suffit plus ?',
        answer:
          'Lite fonctionne sur la même plateforme que Geofleet. Quand il vous faut plus de chauffeurs, plus de hubs ou des agents IA de dispatch, vous passez à un plan Geofleet payant et conservez toutes vos données.',
      },
      {
        question: 'Puis-je importer mes commandes existantes ?',
        answer: 'Oui. Ajoutez les commandes une par une, importez un CSV ou utilisez Lite Plus pour synchroniser Shopify et WooCommerce.',
      },
    ],

    ctaTitle: 'Envoyez votre première livraison avec Lite dès aujourd’hui',
    ctaText: 'Commencez à 49 $ par mois avec 3 chauffeurs et 500 commandes. Passez à Lite Plus pour les tournées, l’attribution automatique et WhatsApp, ou à Lite Autopilot pour confier le dispatch à l’IA.',
    ctaTalk: 'Parlons-en',
  },
  home: {
    liteTeaser: {
      heroPill: 'Geofleet Lite pour les équipes à un seul hub, dès 49 $/mois',
      badge: 'Nouveau',
      title: 'Vous livrez depuis une seule boutique ou un seul entrepôt ?',
      text: 'Découvrez Geofleet Lite : commandes, tournées, suivi en direct et preuve de livraison dans une seule app simple, dès 49 $ par mois avec 3 chauffeurs et 500 commandes.',
      cta: 'Découvrir Geofleet Lite',
    },
  },
};
